import React, { useState, useEffect } from "react";
import ChristmasBanner from "../assets/banners/ChristmasBanner.jpg";
import logo from "../assets/logo/greenwich-logo.png";
import { MdMedicalServices, MdLocalPharmacy } from "react-icons/md";
import { FaStethoscope, FaHeartbeat } from "react-icons/fa";
import { GiMedicines, GiHamburgerMenu } from "react-icons/gi";
import { HashLink as Link } from "react-router-hash-link";
import Snowfall from "./ui/Snowfall";


export default function ChristmasLandingPage() {
  const today = new Date();
  const holidayEndDate = new Date("2026-01-01T23:59:59");
  const showHolidayNotice = today <= holidayEndDate;
  return (
    <div className="relative w-full h-full font-sans">
      {/* Hero Section */}
      <section
        id="home"
        className="relative h-screen w-full flex items-center justify-center text-white overflow-hidden pt-10 md:pt-24" 
      >
        {/* Background */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${ChristmasBanner})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-black/30 via-red-600/20 to-yellow-400/10 backdrop-blur-sm" />

        {/* ❄ Snowflakes */}
      <Snowfall count={60} />

        {/* Content */}
        {/* Main Content */}
        <div className="relative z-10 text-center max-w-3xl px-8 py-20 md:py-16 bg-black/40 backdrop-blur-xl rounded-3xl shadow-[0_0_50px_rgba(255,255,255,0.15)] border border-white/10">

          {/* Icons */}
          <div className="flex justify-center space-x-6 mb-8 text-4xl text-yellow-300 drop-shadow-xl">
            <FaStethoscope />
            <FaHeartbeat />
            <MdLocalPharmacy />
          </div>

          {/* Badge */}
          <div className="mb-8">
            <span className="bg-red-600 text-white font-bold px-5 py-2 rounded-full shadow-lg animate-pulse tracking-wide border border-white/20">
              Accepting New Patients!
            </span>
          </div>

          {/* Holiday Notice */}
{showHolidayNotice && (
<p className="mb-6 text-sm md:text-base text-yellow-200 bg-black/40 inline-block px-4 py-2 rounded-full border border-yellow-300/30 animate-lightBounce">
🎄 Holiday hours are in effect. Please check our <Link to="/#contactus" className="underline font-semibold hover:text-yellow-300">hours of operation</Link> before visiting.
</p>
)}

          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-6 text-yellow-300 drop-shadow-[0_0_15px_rgba(255,215,0,0.5)]">
            Supporting Your Health Journey With Compassion & Care
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-white/90 font-light leading-relaxed mb-10">
            Compassionate care, expert professionals, and convenient access —
            <span className="font-medium text-yellow-200">all under one roof.</span>
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-5 mb-10">
            <Link
              to="/medical-services"
              className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-semibold rounded-full shadow-xl transition-all duration-300 hover:scale-105 drop-shadow-lg"
            >
              <MdMedicalServices className="text-xl" />
              Medical Services
            </Link>

            <Link
              to="/pharmacy-services"
              className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold rounded-full shadow-xl transition-all duration-300 hover:scale-105 drop-shadow-lg"
            >
              <GiMedicines className="text-xl" />
              Pharmacy Services
            </Link>
          </div>
        </div>


        {/* Snow animation */}
        <style>
          {`
            @keyframes fall {
              0% { transform: translateY(-10px); }
              100% { transform: translateY(100vh); }
            }
            @keyframes lightBounce {
              0%, 100% { transform: translateY(0); opacity: 0.7; }
              50% { transform: translateY(-6px); opacity: 1; }
            }
            .animate-lightBounce { animation: lightBounce 2s ease-in-out infinite; }
            .pulse-glow { animation: pulse 2s infinite; }
            @keyframes pulse {
              0%,100% { box-shadow:0 0 5px rgba(255,255,255,0.5);}
              50% { box-shadow:0 0 15px rgba(255,255,0,0.8);}
            }
          `}
        </style>
      </section>
    </div>
  );
}
